var _style, _path, _path2, _path3, _g, _path4, _path5, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#338AF3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0-31.3-5.6-61.3-15.9-89L256,155.8L15.9,167C5.6,194.7,0,224.7,0,256s5.6,61.3,15.9,89L256,356.2 L496.1,345C506.4,317.3,512,287.3,512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c110.1,0,203.9-69.5,240.1-167H15.9C52.1,442.5,145.9,512,256,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.9,167h480.2C459.9,69.5,366.1,0,256,0S52.1,69.5,15.9,167z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.8,178.1h-44.5l7.4-55.7l29.7-22.3l29.7,22.3V167L322.8,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.2,178.1h44.5l-7.4-55.7l-29.7-22.3L167,122.4V167L189.2,178.1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.7,178.1h-59.4v-55.7l29.7-22.3l29.7,22.3V178.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167,167v122.4c0,29.2,14.1,55.1,35.8,71.3l15.6-3.9l19.7,19.8c5.8,1.2,11.8,1.8,18,1.8 c6.1,0,12.1-0.6,17.9-1.8l22.4-18.7l12.9,2.8c21.7-16.3,35.8-42.2,35.8-71.3V167L167,167z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167,167h35.6v35.6H167V167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.2,167h35.6v35.6h-35.6L238.2,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.4,167H345v35.6h-35.6V167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.6,202.6h35.6v35.6h-35.6V202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.8,202.6h35.6v35.6h-35.6V202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167,238.2h35.6v35.6H167V238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.6,273.8h35.6v35.6h-35.6V273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.2,238.2h35.6v35.6h-35.6L238.2,238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.4,238.2H345v35.6h-35.6V238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.8,273.8h35.6v35.6h-35.6V273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.2,309.4h35.6V345h-35.6L238.2,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.6,309.4h-33.3c3.1,13.2,9.1,25.4,17.3,35.6h16V309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.4,345h16c8.2-10.3,14.2-22.4,17.3-35.6h-33.3V345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.6,345v15.5c10.4,7.8,22.5,13.4,35.6,16.1V345L202.6,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.8,345v31.6c13.2-2.7,25.3-8.3,35.6-16.1V345H273.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.32421eb7a2ee6b45afe0abe452349786.svg";
export { ForwardRef as ReactComponent };